var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.513,
    height: 41.394,
    viewBox: "0 0 42.513 41.394",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1511",
    "data-name": "Group 1511",
    transform: "translate(-81 104.394) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1513",
    "data-name": "Group 1513",
    transform: "translate(63 81)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 20.697,
    cy: 21.256,
    rx: 20.697,
    ry: 21.256
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1512",
    "data-name": "Group 1512"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M7.984,9.516.317,1.849A1.083,1.083,0,0,1,1.849.317L7.984,6.451,14.118.317A1.083,1.083,0,0,1,15.65,1.849Z",
    transform: "translate(12.711 13.319)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4-2",
    "data-name": "Path 4",
    d: "M7.984,9.516.317,1.849A1.083,1.083,0,0,1,1.849.317L7.984,6.451,14.118.317A1.083,1.083,0,0,1,15.65,1.849Z",
    transform: "translate(28.679 29.835) rotate(180)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.784401f4b3b87f1804058389167d169e.svg";
export { ForwardRef as ReactComponent };